import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Panel, PanelGroup, designSystem } from '@yola/ws-ui';
import BusinessCategoryFieldContainer from '../../../containers/business-category-field-container';

const {
  DialogHeader,
  DialogHeaderTitle,
  ControlGroup,
  DialogHeaderControls,
  DialogHeaderIconButton,
  ActionButton,
} = designSystem;

const FilterTemplatesDialog = ({
  control,
  stepId,
  captions,
  submitButtonDisabled,
  controlSubmitButtonState,
  onCategorySelect,
  onInput,
  onClose,
  onSubmit,
}) => (
  <Modal
    isBodyScrollDisabled
    draggable={false}
    resizable={false}
    fullscreen
    className="ws-filter-templates-modal"
  >
    <PanelGroup className="ws-filter-templates-modal__panel-group" height="100%">
      <Panel>
        <DialogHeader>
          <DialogHeaderTitle>{captions.title}</DialogHeaderTitle>
          <DialogHeaderControls>
            <DialogHeaderIconButton onClick={onClose} glyph="close" />
          </DialogHeaderControls>
        </DialogHeader>
      </Panel>
      <Panel height="100%">
        <div className="ws-filter-templates-modal__content">
          <ControlGroup title={captions.groupLabel}>
            <BusinessCategoryFieldContainer
              control={control}
              stepId={stepId}
              size="medium"
              openMenu={submitButtonDisabled}
              validate={controlSubmitButtonState}
              onChange={onCategorySelect}
              onInput={onInput}
            />
          </ControlGroup>
          <ActionButton
            fullWidth
            appearance="accent"
            format="solid"
            label={captions.submitButtonLabel}
            disabled={submitButtonDisabled}
            onClick={onSubmit}
          />
        </div>
      </Panel>
    </PanelGroup>
  </Modal>
);

FilterTemplatesDialog.propTypes = {
  control: PropTypes.shape({}).isRequired,
  stepId: PropTypes.string.isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string,
    groupLabel: PropTypes.string,
    submitButtonLabel: PropTypes.string,
  }).isRequired,
  submitButtonDisabled: PropTypes.bool,
  controlSubmitButtonState: PropTypes.func.isRequired,
  onCategorySelect: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

FilterTemplatesDialog.defaultProps = {
  submitButtonDisabled: false,
};

export default FilterTemplatesDialog;
